import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentEmailReport: null,
  emailReports: [],
}

export const emailReportSlice = createSlice({
  name: 'emailReport',
  initialState,
  reducers: {
    setEmailReports: (state, action) => ({
      ...state,
      emailReports: action.payload
    }),
    addEmailReport: (state, action) => ({
      ...state,
      emailReports: [
        ...state.emailReports,
        action.payload
      ]
    }),
    updateEmailReport: (state, action) => ({
      ...state,
      emailReports: state.emailReports.map((emailReport) => {
        if (emailReport.id === action.payload.id)
          return { ...emailReport, ...action.payload.data };
        return emailReport;
      }),
    }),
    removeEmailReport: (state, action) => ({
      ...state,
      emailReports: state.emailReports.filter((emailReport) => {
        return emailReport.id !== action.payload;
      }),
    }),
    setCurrentEmailReport: (state, action) => ({
      ...state,
      currentEmailReport: action.payload
    })
  }

})
export const {
  setEmailReports,
  addEmailReport,
  updateEmailReport,
  removeEmailReport,
  setCurrentEmailReport,
} = emailReportSlice.actions


export default emailReportSlice.reducer